/*
 * De-duplicates the "Lignende produkter" (related) grid against the
 * "Passer godt med" (complementary) block on the product page.
 *
 * Both are <product-recommendations> elements that fetch their cards async and
 * independently (see global.js). Shopify doesn't cross-exclude them, so the same
 * product can appear in both. This hides any related card whose product also
 * appears in the complementary block.
 *
 * To avoid a shorter related row, related over-fetches (data-url limit is raised)
 * and we cap the *visible* count at data-display-limit here — so after dropping
 * duplicates there are spare cards to backfill up to the configured number.
 *
 * Cards are hidden via inline display (not removed) so the filter recomputes
 * correctly no matter which block loads first (e.g. complementary loading after
 * related still backfills, because the spare cards are still in the DOM).
 */
(function () {
  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function cardHandle(el) {
    var a = el.querySelector('a[href*="/products/"]');
    return a ? handleFromHref(a.getAttribute('href')) : '';
  }

  function complementaryHandles() {
    var set = new Set();
    document
      .querySelectorAll('.complementary-products a[href*="/products/"]')
      .forEach(function (a) {
        var h = handleFromHref(a.getAttribute('href'));
        if (h) set.add(h);
      });
    return set;
  }

  function process(related) {
    var grid = related.querySelector('.product-grid');
    if (!grid) return;
    if (!grid.querySelector(':scope > .grid__item')) return;

    var dropped = complementaryHandles();

    // 1) Remove duplicates ENTIRELY (not just hide). The same product appearing
    //    in both the related grid and the complementary block produces duplicate
    //    element ids (e.g. card-product-<id>), which breaks the complementary
    //    slider/cards. Removing the related copy leaves the complementary copy as
    //    the sole holder of those ids. (A related duplicate is never wanted anyway.)
    grid.querySelectorAll(':scope > .grid__item').forEach(function (item) {
      var handle = cardHandle(item);
      if (handle && dropped.has(handle)) item.remove();
    });

    // 2) Cap the remaining (non-duplicate) cards to the configured count by hiding
    //    the over-fetched extras. They stay in the DOM (and are non-duplicates, so
    //    no id clash) so a later complementary load can re-run this and backfill.
    //    Toggling inline display is an attribute change — NOT observed below (we
    //    only watch childList), so it never re-triggers the observer.
    var limit = parseInt(related.dataset.displayLimit, 10);
    if (!limit) return;
    grid.querySelectorAll(':scope > .grid__item').forEach(function (item, i) {
      item.style.display = i < limit ? '' : 'none';
    });
  }

  function init() {
    var relatedEls = document.querySelectorAll('product-recommendations.related-products');
    if (!relatedEls.length) return;
    var complementaryEls = document.querySelectorAll('product-recommendations.complementary-products');

    relatedEls.forEach(function (related) {
      var run = function () {
        process(related);
      };
      run(); // in case it's already populated

      // Re-run when the related grid gets its cards injected...
      new MutationObserver(run).observe(related, { childList: true, subtree: true });
      // ...and when the complementary block loads (so we can backfill/dedup
      // regardless of which finished first).
      complementaryEls.forEach(function (comp) {
        new MutationObserver(run).observe(comp, { childList: true, subtree: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
